import { z } from 'zod';

export const PortPerformanceSnapshot = z.object({
  id: z.string(),
  tenantId: z.string(),
  portCode: z.string(),
  portName: z.string(),
  coordinates: z.object({ lat: z.number(), lng: z.number() }),
  windowStart: z.string(),
  windowEnd: z.string(),
  metrics: z.object({
    vesselDwellHoursMedian: z.number(),
    gateDwellHoursMedian: z.number(),
    customsClearanceHoursMedian: z.number(),
    turnTimeHoursMedian: z.number(),
    sampleCount: z.number(),
  }),
  benchmarkMedian: z.number().nullable(),
  variancePct: z.number(),
  generatedAt: z.string(),
});

export const RailDwellSnapshot = z.object({
  id: z.string(),
  tenantId: z.string(),
  yardCode: z.string(),
  yardName: z.string(),
  coordinates: z.object({ lat: z.number(), lng: z.number() }),
  windowStart: z.string(),
  windowEnd: z.string(),
  metrics: z.object({
    inboundDwellHoursMedian: z.number(),
    outboundDwellHoursMedian: z.number(),
    storageDwellHoursMedian: z.number(),
    sampleCount: z.number(),
  }),
  benchmarkMedian: z.number().nullable(),
  variancePct: z.number(),
  generatedAt: z.string(),
});

export const HeatmapDataPoint = z.object({
  coordinates: z.object({ lat: z.number(), lng: z.number() }),
  intensity: z.number(),
  category: z.enum(['origin', 'destination', 'in-transit', 'exception-cluster']),
  countAtPoint: z.number(),
});

export const GeoCommentary = z.object({
  id: z.string(),
  tenantId: z.string(),
  surfaceKind: z.enum(['port-performance', 'rail-dwell', 'heatmap']),
  topInsights: z.array(z.string()),
  body: z.string(),
  confidence: z.number().min(0).max(1),
  generatedAt: z.string(),
  correlationId: z.string(),
});
